import Banner from '@zenbusiness/zui/Banner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';

import UploadDocumentsModal from '#client/components/UploadDocumentsModal';
import { APPLICATION_STATUS } from '#client/constants/application';
import useApplicationStatusContext from '#client/hooks/useApplicationStatusContext';
import useModalContext from '#client/hooks/useModalContext';
import { BannerWrapperStyled } from '#client/pages/SharedStyles';

export default function ApplicationDocsStatusBanner() {
  const { docsStatus, loading } = useApplicationStatusContext();
  const { openModal } = useModalContext();

  if (loading) {
    return undefined;
  }

  switch (docsStatus) {
    case APPLICATION_STATUS.APPROVED:
      return null;
    case APPLICATION_STATUS.AWAITING:
      return (
        <BannerWrapperStyled>
          <Banner
            slotProps={{
              primaryAction: {
                label: 'Upload documents',
                onClick: () => {
                  openModal({
                    component: UploadDocumentsModal
                  });
                }
              }
            }}
            slots={{
              startIcon: (
                <SharedAsset
                  alt=""
                  src="/icon/micro/alert-fill.svg"
                />
              )
            }}
            subtitle="We need more documents to finish processing your application."
            sx={(theme) => ({ backgroundColor: theme.palette.background.grey.light })}
            title="Your banking application is paused"
          />
        </BannerWrapperStyled>
      );
    case APPLICATION_STATUS.PENDING_REVIEW:
      return (
        <BannerWrapperStyled>
          <Banner
            subtitle="You’ll get an email in 1 to 3 business days if you were approved or we need more info."
            title="Your application is processing"
          />
        </BannerWrapperStyled>
      );
    default:
      return null;
  }
}
